var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsString, IsUUID } from 'class-validator';
import { OfficeLocationStub } from './office-location-stub.dto.js';
export class OfficeLocationNewsFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    text;
    publishStart;
    publishEnd;
    officeLocationId;
    officeLocation;
    // only used for ability check
    officeId;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeLocationNewsFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeLocationNewsFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeLocationNewsFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeLocationNewsFullSizeDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeLocationNewsFullSizeDto.prototype, "text", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationNewsFullSizeDto.prototype, "publishStart", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], OfficeLocationNewsFullSizeDto.prototype, "publishEnd", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeLocationNewsFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeLocationStub),
    __metadata("design:type", Function)
], OfficeLocationNewsFullSizeDto.prototype, "officeLocation", void 0);
//# sourceMappingURL=office-location-news.dto.js.map